import { QUERY_KEYS } from 'api/query-keys';
import { flexPoolService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';

export const useDeleteFlexPool = () => {
  const queryClient = useQueryClient();
  const mutationFn = async (flexPoolId: string) => await flexPoolService.deleteFlexPool(flexPoolId);

  return useMutation(mutationFn, {
    onSettled: async () => {
      queryClient.invalidateQueries(QUERY_KEYS.flexPools());
      queryClient.invalidateQueries(QUERY_KEYS.statistics());
    },
  });
};
